import * as React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { GetWorkSpaceDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import AddWorkSpace from 'modules/locations/components/AddWorkSpace'
import { useMapWorkAreasFlag } from 'modules/locations/hooks/useMapWorkAreasFlag'
import workSpaces from 'modules/space_control/store/collections/workSpaces'
import { WorkSpacesProvider } from 'modules/space_control/store/collections/workSpaces'

const AddWorkSpacePage = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const hasMapWorkAreasFlag = useMapWorkAreasFlag()
  const params = useParams()
  const locationId = Number(params.id)
  const workAreaId = Number(params.workAreaId)
  const workSpaceId = Number(params.workSpaceId)

  const { loading, data: workSpaceData } = useQuery(GetWorkSpaceDocument, {
    variables: { id: workSpaceId || 0 },
    skip: !workSpaceId,
  })
  const workSpace = workSpaceData?.spaceControl.workSpace

  const onClose = () => {
    if (hasMapWorkAreasFlag) {
      navigate(
        navigation.settings.locations.locationsId.workAreas.workSpaces.fullPath({
          id: locationId,
          workAreaId: workAreaId,
        })
      )
    } else {
      navigate(navigation.settings.locations.locationsId.workAreas.fullPath({ id: locationId }))
    }
  }

  if (loading) {
    return <></>
  }
  return (
    <WorkSpacesProvider collection={workSpaces}>
      <AddWorkSpace
        onClose={onClose}
        workAreaId={workAreaId}
        workSpace={workSpace}
        locationId={locationId}
      />
    </WorkSpacesProvider>
  )
}

export default AddWorkSpacePage
